import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

export const paymentRoutes: Routes = [
  {
    path: 'payment',
    loadComponent: () =>
      import('@pages/common/payment-management/payment-management').then(
        (m) => m.PaymentManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
];
